module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.wxaCodeImage) ? _c('div', {
    staticClass: "content-center"
  }, [_c('el-row', [_c('el-col', [_c('img', {
    attrs: {
      "src": _vm.wxaCodeImage
    }
  })]), _vm._v(" "), _c('el-col', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.downDistributorCode
    }
  }, [_vm._v("下载"), _c('i', {
    staticClass: "el-icon-download el-icon--right"
  })])], 1)], 1)], 1) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-250c387a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-250c387a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/marketing/distributorCode.vue
// module id = 2545
// module chunks = 0